module.exports = {"data":{"site":{"siteMetadata":{"appUrl":"https://pipeline.social/m/subscribe/"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 200
// module chunks = 60335399758886 79611799117203